/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import {
  AiOutlineMail,
  AiFillAudio,
  AiOutlineBorderInner,
  AiOutlineConsoleSql,
  AiTwotoneBug,
  AiOutlineCode,
  AiOutlineDeploymentUnit,
} from "react-icons/ai";
import {
  FaInternetExplorer,
  FaChalkboardTeacher,
  FaCameraRetro,
  FaPinterest,
  FaVideo,
  FaHandHoldingHeart,
  FaTabletAlt,
  FaRegNewspaper,
} from "react-icons/fa";
import { GrOptimize } from "react-icons/gr";

export const servicesData = [
  {
    id: 1,
    title: "Full Stack Web Development",
    icon: <BsCodeSlash />,
  },
  {
    id: 2,
    title: "Frontend Development",
    icon: <AiOutlineCode />,
  },
  {
    id: 3,
    title: "Backend Development",
    icon: <AiOutlineConsoleSql />,
  },
  {
    id: 4,
    title: "NFT & Web3 Integration",
    icon: <AiOutlineBorderInner />,
  },
  {
    id: 5,
    title: "E-commerce Development",
    icon: <BiShoppingBag />,
  },
  // {
  //   id: 6,
  //   title: "RESTful API Development",
  //   icon: <AiOutlineDeploymentUnit />,
  // },
  {
    id: 7,
    title: "Database Design & Optimization",
    icon: <BsClipboardData />,
  },
  {
    id: 8,
    title: "Real-time Chat Applications",
    icon: <AiOutlineMail />,
  },
  // {
  //   id: 9,
  //   title: "Performance Optimization",
  //   icon: <GrOptimize />,
  // },
  {
    id: 10,
    title: "PWA Development",
    icon: <FaTabletAlt />,
  },
  {
    id: 11,
    title: "Bug Fixing & Maintenance",
    icon: <AiTwotoneBug />,
  },
  {
    id: 12,
    title: "Client Satisfaction Guaranteed",
    icon: <FaHandHoldingHeart />,
  },
];

// Services offered based on 2+ years of MERN Stack expertise
// Specialized in NFT marketplaces, healthcare systems, e-commerce platforms, and real-time applications
